module.exports = __webpack_public_path__ + "img/EN.981f252e.svg";